// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import type { ContextRouter } from 'react-router';
import { Route, Redirect } from 'react-router-dom';

type OwnProps = {
  component?: React$ComponentType<*>,
  render?: (router: ContextRouter) => React$Node,
  path: string
};

type Props = {
  ...$Exact<OwnProps>,
  loggedIn: boolean
};

const AuthenticatedRoute = ({
  component: Component,
  render,
  loggedIn,
  path,
  ...rest
}: Props) => (
  <Route
    {...rest}
    path={path}
    render={(router: ContextRouter) => {
      if (!loggedIn) {
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: {
                redirectTo: `${router.location.pathname}?${
                  router.location.search
                }`,
                flashMessage: { type: 'LOGIN_REQUIRED' },
                title:
                  path === '/post-a-listing'
                    ? getText('Log in to Post a Listing')
                    : undefined
              }
            }}
          />
        );
      }
      if (Component) {
        return <Component {...router} />;
      }
      if (render) {
        return render(router);
      }
      throw new Error('component or render prop is required');
    }}
  />
);

const mapStateToProps = ({ currentUser }) => ({
  loggedIn: currentUser && !currentUser.isLoading && currentUser.id
});

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(
  AuthenticatedRoute
);
